/**
 * scrollWithinContainer(el) — scrolls the NEAREST scrollable ancestor of
 * `el` to its bottom (or top), without ever scrolling the whole page.
 *
 * Every chat surface in the app (TaskWorkspace, GuidanceWorkspace, ChatPage,
 * FloatingChat, DMDrawer, ProjectChat, …) used to call
 * `endRef.current.scrollIntoView(...)` which walks up until it hits the
 * document element — so opening a chat that already had messages would
 * yank the whole page down. This helper only touches the closest scrollable
 * ancestor.
 */
export function scrollWithinContainer(el, { direction = "bottom", smooth = true } = {}) {
  if (!el) return;
  let p = el.parentElement;
  while (p && p !== document.body) {
    const s = getComputedStyle(p);
    if (/(auto|scroll|overlay)/.test(s.overflowY)) {
      const target = direction === "top" ? 0 : p.scrollHeight;
      try {
        p.scrollTo({ top: target, behavior: smooth ? "smooth" : "auto" });
      } catch {
        p.scrollTop = target;
      }
      return;
    }
    p = p.parentElement;
  }
}
